module.exports = __webpack_public_path__ + "img/图4.63976ac6.png";